import React from "react";
export default function PhysicalAfter() {
  return (
    <>
      <section className="physical-after-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="physical-after-box">
                <span>Without Dox and Box</span>
                <p>Disorganized Records, Security Risks, Operational Delays </p>
                <ul>
                  <li>Disorganized storage and misplaced files</li>
                  <li>Time-consuming manual searches</li>
                  <li>High risk of damage, loss, or unauthorized access</li>
                  <li>Inefficient use of office space</li>
                  <li>No visibility into record movement</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="physical-after-box physical-after-black">
                <span>With Dox and Box</span>
                <p>Secure, Structured, Efficient Physical Records Management </p>
                <ul>
                  <li>Structured, indexed, secure storage</li>
                  <li>Fast and reliable record retrieval</li>
                  <li>Controlled access with complete audit trails</li>
                  <li>Optimized space and reduced overhead</li>
                  <li>Full visibility and tracking of every record</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}